<template>
    <v-list
        dense
        nav
        class="pt-0 px-2 pb-0"
    >
        <div :style="{ height: '48px' }" class="d-flex">
            <v-img
                :src="cdn_url('core/white_logo.svg')"
                width="80px"
                max-width="80px"
                contain
            />
        </div>
    </v-list>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.v-list {
    background: var(--v-app-bar-base) !important;

    height: 48px;
    position: fixed;
    width: 100%;
    z-index: 2;
}
</style>
